import { colors } from '@mui/material';

const obj = {
  root: {
    backgroundColor: colors.grey[50]
  }
};

export default obj;
